import React from 'react';
import { ICON_COMPONENT_MAP } from './lucideIconMap';
import { Square } from 'lucide-react';

/**
 * Renders a Lucide icon by kebab-case name string.
 * Falls back to a transparent square placeholder if name not found.
 */
export default function SchemaIcon({ iconName, size = 14, style, className, ...rest }) {
  const IconComponent = ICON_COMPONENT_MAP[iconName];
  if (!IconComponent) {
    return <Square size={size} strokeWidth={1.5} style={{ ...style, opacity: 0.15 }} className={className} {...rest} />;
  }
  return <IconComponent size={size} strokeWidth={2} style={style} className={className} {...rest} />;
}
